import React from 'react';
import { useSupportChatMessages } from './useSupportChatMessages';
import { useSupportChatComposer } from './useSupportChatComposer';
import SupportChatMessageList from './SupportChatMessageList';
import SupportChatComposer from './SupportChatComposer';

const SupportChatWindow = () => {
  const { messages, loading, loadingOlder, hasMoreOlder, loadOlder, refetchMessages, addPendingMessage, removePendingMessage } =
    useSupportChatMessages();
  const composer = useSupportChatComposer({ onSent: refetchMessages, addPendingMessage, removePendingMessage });

  return (
    <div className="min-h-screen p-2 sm:p-4 bg-gradient-to-r from-[#ededed] to-[#dcdcdc] flex justify-center">
      <div className="w-full max-w-2xl flex flex-col gap-3">
        <h2 className="text-2xl font-semibold text-gray-800 px-1">Чат с поддержкой</h2>
        <div className="flex-1 bg-white rounded-3xl shadow-lg flex flex-col min-h-[420px] max-h-[calc(100vh-140px)] overflow-hidden">
          <SupportChatMessageList
            messages={messages}
            loading={loading}
            loadingOlder={loadingOlder}
            hasMoreOlder={hasMoreOlder}
            onLoadOlder={loadOlder}
          />
          <SupportChatComposer {...composer} />
        </div>
      </div>
    </div>
  );
};

export default SupportChatWindow;
